module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Bold.3e48e58e.woff2";